<section class="edp-widget-funciona edp-card-widget card">

  <div class="card-header">
    <span class="card-title">{{ "pt.edp.edponline.seamless.funciona" | translate }}</span>
    <span class="card-icon">
      <i class="edp-color-seaweed-green-01"
        [ngClass]="{'icon-edponline-Bop-002': !selectedContract?.HasPack, 'icon-edponline-Bop-091': selectedContract?.HasPack}"
        aria-hidden="true"></i>
    </span>
  </div>

  <div class="card-body card-body pt-0 d-flex flex-column">
    <div class="container-chart">
      <div id="chart-funciona-element" #chartFuncionaElement></div>

      <div class="overlay">
        <ng-container *ngTemplateOutlet="overlayCounter"></ng-container>
      </div>
    </div>

    <ng-container *ngIf="!highPercentageUsed; else textAlert">
      <div class="subtitles d-flex align-items-center justify-content-around">
        <span class="subtitles-label d-flex align-items-center">
          <div class="subtitles-marker"></div>
          {{ "pt.edp.edponline.widget.funciona.subtitle.completed" | translate }}
        </span>
        <span class="subtitles-label d-flex align-items-center">
          <div class="subtitles-marker subtitles-marker-available"></div>
          {{ "pt.edp.edponline.widget.funciona.subtitle.available" | translate }}
        </span>
      </div>
    </ng-container>

    <div class="container-button">
      <ng-container *ngIf="!plafondCompleted; else buttonPlafondCompleted">
        <button (click)="goToRequest()" class="btn edp-primary-btn edp-large-button">
          {{"pt.edp.edponline.service.funciona.tech.assist.askAssist" | translate}}
        </button>
      </ng-container>
    </div>
  </div>
</section>

<ng-template #buttonPlafondCompleted>
  <button (click)="goToPacks()" [disabled]="!!isFull" class="btn edp-secondary-btn edp-large-button">
    {{"pt.edp.edponline.widget.funciona.increase.plafond" | translate}}
  </button>
</ng-template>

<ng-template #textAlert>
  <ng-container *ngIf="!isFull">
    <div class="text-alert">
      <span>
        {{ plafondCompleted
        ? ("pt.edp.edponline.widget.funciona.alert.warning" | translate)
        : ("pt.edp.edponline.widget.funciona.alert.completed" | translate)
        }}
      </span>
      <ng-container *ngIf="!plafondCompleted">
        <span (click)="goToPacks()" class="text-alert-action edp-text-seaweed-green cursor-pointer">
          {{"pt.edp.edponline.widget.funciona.increase.plafond" | translate}}
        </span>
      </ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #overlayCounter>
  <div class="overlay-counter">
    <ng-container *ngIf="!plafondCompleted; else overlayCounterCompleted">
      <span class="overlay-counter-label">
        {{ "pt.edp.edponline.widget.counter.funciona.legend.has" | translate }}
      </span>
      <span class="overlay-counter-value">
        <span class="overlay-counter-value-big" [innerHTML]="dataChart.plafondAvailable | edpDecimalSplit">
        </span>
      </span>
      <span class="overlay-counter-label">
        {{ "pt.edp.edponline.widget.counter.funciona.legend.year" | translate }}
      </span>
    </ng-container>
  </div>
  <ng-template #overlayCounterCompleted>
    <span class="overlay-counter-label completed">
      {{ "pt.edp.edponline.widget.counter.funciona.legend.completed" | translate }}
    </span>
  </ng-template>
</ng-template>